import { PictureId } from "./pictureArt.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";
import { StringKey } from "../../Shared/i18n/strings.ts";

/*
 * The words that go with each of Hidden Picture's pictures (ADR 0133 §2): a hint
 * for the start screen, which names the occasion and never the picture, and the
 * caption the end screen puts under the whole picture. Every key is written out
 * as a `labelKey` in a file that uses `useTranslation`, so StringKeys.test.js sees it, as
 * QuizPage's modes do.
 */

const PICTURE_HINTS: Record<PictureId, { labelKey: StringKey }> = {
    snowman: { labelKey: "flashCards.pictureHintSnowman" },
    heart: { labelKey: "flashCards.pictureHintHeart" },
    shamrock: { labelKey: "flashCards.pictureHintShamrock" },
    tulip: { labelKey: "flashCards.pictureHintTulip" },
    icecream: { labelKey: "flashCards.pictureHintIcecream" },
    apple: { labelKey: "flashCards.pictureHintApple" },
    pumpkin: { labelKey: "flashCards.pictureHintPumpkin" },
    turkey: { labelKey: "flashCards.pictureHintTurkey" },
    gift: { labelKey: "flashCards.pictureHintGift" },
};

const PICTURE_CAPTIONS: Record<PictureId, { labelKey: StringKey }> = {
    snowman: { labelKey: "flashCards.pictureCaptionSnowman" },
    heart: { labelKey: "flashCards.pictureCaptionHeart" },
    shamrock: { labelKey: "flashCards.pictureCaptionShamrock" },
    tulip: { labelKey: "flashCards.pictureCaptionTulip" },
    icecream: { labelKey: "flashCards.pictureCaptionIcecream" },
    apple: { labelKey: "flashCards.pictureCaptionApple" },
    pumpkin: { labelKey: "flashCards.pictureCaptionPumpkin" },
    turkey: { labelKey: "flashCards.pictureCaptionTurkey" },
    gift: { labelKey: "flashCards.pictureCaptionGift" },
};

/** The hint and the caption for a picture, in the player's language. */
export function usePictureText() {
    const t = useTranslation();
    return {
        hint: (id: PictureId) => t(PICTURE_HINTS[id].labelKey),
        caption: (id: PictureId) => t(PICTURE_CAPTIONS[id].labelKey),
    };
}
